import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'usuarios/funciones';

/**
 * GET Funciones
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getFunciones = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Funcion
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getFuncion = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Funcion
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postFuncion = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Funcion
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchFuncion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Funcion
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteFuncion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
